import React, {ReactNode} from "react";

export function ClickIsolation(props: {children: ReactNode}) {
	return <span onClick={event => event.stopPropagation()}>
		{props.children}
	</span>;
}
